import Component from '@glimmer/component';

import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import willDestroy from '@ember/render-modifiers/modifiers/will-destroy';

import CIcon from 'rise-ui/components/c-icon.gjs';
import and from 'rise-ui/helpers/and.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import classModConfig from 'rise-ui/helpers/class-mod-config.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import isNoUrl from 'rise-ui/helpers/is-no-url.js';
import isTruthy from 'rise-ui/helpers/is-truthy.js';
import not from 'rise-ui/helpers/not.js';
import or from 'rise-ui/helpers/or.js';
import registerUrl from 'rise-ui/helpers/register-url.js';

export default class LinksToLinkComponent extends Component {
  <template>
    {{~#let
      (classModConfig
        (concatClasses "c-links-to" @linksTo.args.classMix)
        (or @linksTo.disabled (isNoUrl @linksTo.href)) "--disabled"
        @linksTo.isOpen "--external"
      )
      as | classModCfg |
    ~}}
    <a class={{classMod config=@linksTo.args.classModConfig}}
      {{didInsert (registerUrl @linksTo @linksTo.href)}}
      {{didUpdate (registerUrl @linksTo @linksTo.href) @linksTo.href}}
      {{willDestroy (registerUrl @linksTo)}}
       ...attributes
    >
      {{~yield~}}
      {{~#if (and @linksTo.isOpen (not (isTruthy @linksTo.args.noOpenIcon)))}}
        <CIcon
          @classMix={{classMod config=classModCfg suffix="__external-icon"}}
          @icon="external-link"
          @text="Opens in new window"
        />
      {{~/if~}}
    </a>
    {{~/let~}}
  </template>
}
